import { useState } from 'react'
import { profile } from '@content/portfolioData'

const sections = ['about', 'story', 'values', 'projects', 'skills', 'experience', 'writing', 'contact']

interface NavProps {
  scrolled: boolean
  highContrast: boolean
  onToggleContrast: () => void
}

export function Nav({ scrolled, highContrast, onToggleContrast }: NavProps) {
  const [open, setOpen] = useState(false)

  return (
    <nav className={`modern-nav${scrolled ? ' modern-nav--scrolled' : ''}${open ? ' modern-nav--open' : ''}`}>
      <a href="#hero" className="modern-nav__logo" onClick={() => setOpen(false)}>
        {profile.name}
      </a>
      <button
        type="button"
        className="modern-nav__toggle"
        onClick={() => setOpen((prev) => !prev)}
        aria-label={open ? 'Close menu' : 'Open menu'}
        aria-expanded={open}
      >
        <span className="modern-nav__toggle-bar" />
        <span className="modern-nav__toggle-bar" />
        <span className="modern-nav__toggle-bar" />
      </button>
      <ul className={`modern-nav__links${open ? ' modern-nav__links--open' : ''}`}>
        {sections.map((s) => (
          <li key={s}>
            <a
              href={`#${s}`}
              className="modern-nav__link"
              onClick={() => setOpen(false)}
            >
              {s.charAt(0).toUpperCase() + s.slice(1)}
            </a>
          </li>
        ))}
        <li>
          <button
            type="button"
            className="modern-nav__contrast-toggle"
            onClick={onToggleContrast}
            aria-label={highContrast ? 'Switch to normal contrast' : 'Switch to high contrast'}
            aria-pressed={highContrast}
            title={highContrast ? 'Normal contrast' : 'High contrast'}
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <circle cx="8" cy="8" r="6.5" stroke="currentColor" strokeWidth="1.5" />
              <path d="M8 1.5A6.5 6.5 0 0 1 8 14.5Z" fill="currentColor" />
            </svg>
          </button>
        </li>
      </ul>
    </nav>
  )
}
